export default __webpack_public_path__ + "static/media/camera.1d94541c.png";